import './NotFound.scss';

function NotFound() {
	return <div className='not-found-container'>Not found</div>;
}

export default NotFound;
